import React from "react";
import { useVideoConfig } from "remotion";

export const VintageBackground: React.FC = () => {
  useVideoConfig(); // ensures Remotion frame-tracking context is active

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
        overflow: "hidden",
        background: "#1a1208",
      }}
    >
      {/* SVG Film Grain Texture */}
      <svg
        style={{ position: "absolute", top: 0, left: 0, width: 0, height: 0 }}
        aria-hidden="true"
      >
        <defs>
          <filter
            id="grain"
            x="0%"
            y="0%"
            width="100%"
            height="100%"
            colorInterpolationFilters="sRGB"
          >
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.85"
              numOctaves="4"
              seed="2"
              stitchTiles="stitch"
              result="noise"
            />
            <feColorMatrix
              type="saturate"
              values="0"
              in="noise"
              result="grayNoise"
            />
            <feBlend in="SourceGraphic" in2="grayNoise" mode="multiply" />
          </filter>
        </defs>
      </svg>

      {/* Grain overlay div */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          filter: "url(#grain)",
          opacity: 0.12,
          background: "#888",
          zIndex: 1,
        }}
      />

      {/* Warm amber center glow */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(ellipse at 50% 40%, rgba(212,168,83,0.06) 0%, transparent 60%)",
          zIndex: 2,
        }}
      />

      {/* Classic sepia vignette */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(ellipse at 50% 50%, transparent 40%, rgba(26,18,8,0.7) 100%)",
          zIndex: 3,
        }}
      />

      {/* Top film strip border */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "20px",
          background: "#0a0804",
          backgroundImage:
            "repeating-linear-gradient(90deg, transparent 0px, transparent 14px, #1a1208 14px, #1a1208 18px, transparent 18px, transparent 32px)",
          zIndex: 4,
        }}
      />

      {/* Bottom film strip border */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "20px",
          background: "#0a0804",
          backgroundImage:
            "repeating-linear-gradient(90deg, transparent 0px, transparent 14px, #1a1208 14px, #1a1208 18px, transparent 18px, transparent 32px)",
          zIndex: 4,
        }}
      />

      {/* Film strip left sprocket holes */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "20px",
          height: "100%",
          background: "#0a0804",
          backgroundImage:
            "repeating-linear-gradient(180deg, transparent 0px, transparent 14px, #1a1208 14px, #1a1208 18px, transparent 18px, transparent 32px)",
          zIndex: 4,
        }}
      />

      {/* Film strip right sprocket holes */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "20px",
          height: "100%",
          background: "#0a0804",
          backgroundImage:
            "repeating-linear-gradient(180deg, transparent 0px, transparent 14px, #1a1208 14px, #1a1208 18px, transparent 18px, transparent 32px)",
          zIndex: 4,
        }}
      />

      {/* Inner warm glow border — simulates projected light */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          right: "20px",
          bottom: "20px",
          boxShadow: "inset 0 0 60px rgba(212,168,83,0.04)",
          border: "1px solid rgba(212,168,83,0.08)",
          zIndex: 5,
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
